import React, { useContext, useEffect, useState } from 'react'
import Sider from 'antd/es/layout/Sider'
import { Layout, Menu } from 'antd'
import { Content } from 'antd/es/layout/layout'
import { Navigate, NavLink, Outlet, Route, Routes, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppContext } from '../../../App'
import { ContextType } from '../../../type/type'
import { WrapperData } from '../../../style/style'
import Personal from './Personal'
import Phone from './Phone'
import Email from './Email'
import Password from './Password'
import BottomMenuInfo from '../../../modules/BottomMenuInfo/BottomMenuInfo'
import { adminMenu } from '../../../lists/adminMenu'
import MyTrophies from '../../MyTrophies/MyTrophies'
import AddingHuntingGrounds from '../../AddingHuntingGrounds/AddingHuntingGrounds'
import UserManagement from '../../UserManagement/UserManagement'
import ApplicationManagement from '../../ApplicationManagement/ApplicationManagement'
import StatisticManagement from '../../StatisticManagement/StatisticManagement'

const ProtectedSettings = () => {
  const { state } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()

  if (!state?.me?.is_email_verified) {
    return <div>{t('h217')}</div>
  }

  return (
    <WrapperData>
      <Outlet />
    </WrapperData>
  )     
}

const Cabinet = () => {
  const { state, isMobileWidth } = useContext<ContextType>(AppContext)
  const [collapsed, setCollapsed] = useState(false)

  const handleCollapse = (collapsed: boolean, type: string) => {
    if (type === 'clickTrigger') setCollapsed(collapsed)
  }
  const { pathname } = useLocation()
  let type = pathname.split('/cabinet/')[1]
  const [breakpoint, setBreakpoint] = useState(false)

  if (type === 'profile/') {
    type = 'profile/personal'
  }
  const handleClickMenu = () => {
    if (breakpoint) setCollapsed(true)
  }

  return (
    <Layout className="br-12">
      {isMobileWidth ? (
        <Menu
          defaultOpenKeys={['profile']}
          className="w-240"
          selectedKeys={[type]}
          mode="inline"
          items={adminMenu()}
          onClick={handleClickMenu}
        />
      ) : (
        <Sider
          width={270}
          breakpoint="lg"
          collapsedWidth="0"
          className="site-layout-background"
          collapsed={collapsed}
          onBreakpoint={(broken) => setBreakpoint(broken)}
          onCollapse={(collapsed: boolean, type: string) => handleCollapse(collapsed, type)}
          // style={{ paddingBottom: 600 }}
        >
          <Menu
            defaultSelectedKeys={['personal']}
            defaultOpenKeys={['profile']}
            className="w-240"
            selectedKeys={[type]}
            mode="inline"
            items={adminMenu()}
            onClick={handleClickMenu}
          />
          <BottomMenuInfo type="man" />
        </Sider>
      )}
      <Content>
          <Routes>
            <Route path="/profile/*" element={<ProtectedSettings />}>
              <Route index element={<Personal />} />
              <Route path="personal" element={<Personal />} />
              <Route path="phone" element={<Phone />} />
              <Route path="email" element={<Email />} />
              <Route path="password" element={<Password />} />
            </Route>

            <Route path="/my-trophies" element={<MyTrophies />} />

            <Route path="/adding-hunting-grounds" element={<AddingHuntingGrounds />} />

            <Route path="/user-management" element={<UserManagement />} />

            <Route path="/application-management" element={<ApplicationManagement />} />

            <Route path="/statistic" element={<StatisticManagement />} />
          </Routes>
      </Content>
    </Layout>
  )
}

export default Cabinet
